import React, { useState, useEffect, useRef, useCallback } from 'react';
import DashboardHeader from '../include/DashboardHeader';
import DashboardSidebar from '../include/DashboardSidebar';
import DashboardTitle from './dashboard_modules/DashboardTitle';
import { Link, useNavigate } from 'react-router-dom';
import { Row, Col, Modal } from 'react-bootstrap'
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import box_img1 from '../../assets/images/icon_appoint.svg';
import box_img2 from '../../assets/images/icon_order.svg';
import box_img3 from '../../assets/images/icon_photo.svg';
import box_img4 from '../../assets/images/icon_emioption.svg';
import box_img5 from '../../assets/images/icon_orders.svg';
import thankyou_icon from '../../assets/images/thanks_shapes_r.svg';
import surgery_icon from '../../assets/images/surgery.svg';
import Slider from 'react-slick';
import { logout } from "../../actions/auth";
import { useDispatch } from "react-redux";
import useAxiosInstance from '../../Api/AxiosInstance';
import PrescriptionModal from "../include/PrescriptionModal";

const loadScript = (src) => {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = src;
    script.onload = () => resolve(script);
    script.onerror = () => reject(new Error(`Script load error for ${src}`));
    document.head.appendChild(script);
  });
};

const setting1 = {
  dots: false,
  navs: true,
  infinite: true,
  speed: 500,
  slidesToShow: 6,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 3000,
  responsive: [
    {
      breakpoint: 1679,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 1199,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      }
    }
  ]
};
function Dashboard() {
  const dispatch = useDispatch();
  const logOut = useCallback(() => {
    dispatch(logout());
  }, [dispatch]);
  let navigate = useNavigate();
  const [show, setShow] = useState(false);
  const [sliderimg, setSliderimg] = useState([])
  // Consume the login flag when the popup is closed, NOT when it opens.
  // Login does navigate() + window.location.reload(), so Dashboard mounts twice;
  // clearing the flag on mount would let the reload wipe it before it is ever seen.
  const handleClose = () => {
    setShow(false);
    localStorage.removeItem('show_medicine_popup');
  };
  const handleShow = () => setShow(true);
  const [show2, setShow2] = useState(false);
  const [ShowWithoutPrescription, setShowWithoutPrescription] = useState(false);
  const handleClose2 = () => { setShow2(false); setFile1(""); setFileError(''); changeclass1('') }
  const handleCloseWithoutPrescription = () => { handleShowWithoutPrescription(false); setShowWithoutPrescription(false) }
  const handleShow2 = () => setShow2(true);
  const handleShowWithoutPrescription = () => {
    setShowWithoutPrescription(true);
    handleClose();
  };
  const [show3, setShow3] = useState(false);
  const handleClose3 = () => setShow3(false);
  const handleShow3 = () => setShow3(true);
  const [file1, setFile1] = useState("");
  const [fileError, setFileError] = useState("");
  const [file, setFile] = useState();
  const [myclass1, changeclass1] = useState("");
  const user = JSON.parse(localStorage.getItem("user"));
  const AxiosInstance = useAxiosInstance()

  /* ---------------------------------------------------------------------
     AUTO-OPEN "ORDER MEDICINES" POPUP (CHANGED on request)

     Was: open only when localStorage 'show_medicine_popup' === '1'. That flag
     is set by Login (Login.js) and Home.js, and cleared by handleClose - so the
     popup appeared once after logging in and never again. Clicking the logo or
     "My Dashboard" from the shop page skipped it, because the flag was already
     gone.

     Now: the popup opens on EVERY visit to the dashboard, whatever the flag
     says. Dashboard is a route component, so navigating away unmounts it and
     coming back mounts it fresh, which re-runs this effect. That is what makes
     it appear every time rather than once.

     'show_medicine_popup' is now unused on this page. Login/Home still set it
     and handleClose still clears it - both left alone so the one-time
     behaviour can be restored by uncommenting the PREVIOUS block below.

     Note this combines with the backdrop='static' set on the modal itself: the
     popup now appears on every dashboard visit AND cannot be dismissed by
     clicking the background or pressing Escape, so one of its two buttons must
     be chosen before the dashboard can be used. That is what "always on the
     dashboard" implies, but if it turns out to be too insistent the fix is to
     drop backdrop='static' / keyboard={false} from the modal below, or to put
     the flag check back here.
  --------------------------------------------------------------------- */
  useEffect(() => {
    // PREVIOUS (kept for restore):
    // const shouldShowPopup = localStorage.getItem('show_medicine_popup');
    // if (shouldShowPopup === '1') {
    //   setShow(true);
    // }
    setShow(true);
  }, []);

  useEffect(() => {
    loadScript("https://cdn.trustindex.io/loader.js?906599d1520f8065485696d3394").then(() => {
      if (window.Trustindex) {
        window.Trustindex.init();
      }
    }).catch(error => {
      console.error('Error loading Trustindex script:', error);
    });
  }, []);
  function handleChange1(e) {
    const selectedFile = e.target.files[0];
    //const allowedTypes = ["application/pdf", "application/msword", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"];
    //if (selectedFile && allowedTypes.includes(selectedFile.type)) {
      setFileError('');
      setFile1(selectedFile.name);
      setFile(selectedFile);
      changeclass1(`file-uploaded`); // Set the appropriate class for styling
    /*} else {
      setFileError('Only PDF, DOC, and DOCX files are allowed');
    }*/
  }
  const handleClick = () => {
    localStorage.setItem('booking_type', 'surgery');
  };
  const handleAppointmentClick = () => {
    localStorage.setItem('booking_type', 'appointment');
  };
  const form = useRef();
  const fetchImage = async () => {
    /* Paused while results section is hidden */
    // The 'sliders' response only ever fed setSliderimg, which only ever fed the
    // "After & Before results" carousel. That carousel is commented out above,
    // so the request fetched data nothing renders. Kept verbatim so uncommenting
    // this restores the original behaviour exactly.
    // try {
    //   const response = await AxiosInstance.post('sliders')
    //   setSliderimg(response.data.data.slider)
    //
    // } catch (error) {
    //   console.log(error);
    // }
  };

  useEffect(() => {
    /* Paused while results section is hidden */
    // Call site left commented alongside the body in fetchImage() above, so
    // restoring the two together brings the request back and leaves no empty
    // effect behind. The effect still runs on mount and simply does nothing.
    // fetchImage()
  }, [])

  const handleSubmit = async (e) => {

    e.preventDefault();
    if (!file1) {
      setFileError("Please upload prescription document.");
      return;
    }

    const formData = new FormData();
    form.current.validateAll();
    formData.append("prescription_pdf", file);


    try {
      const response = await AxiosInstance.post("upload-priscription" , formData)
      if (response.data.status == 200) {
        handleClose2();
        /*handleShow3();*/
        changeclass1('')
        navigate('/shop'); // Redirect to your target page

      }

    } catch (error) {

    }
  
  };
  return (
    <div className='main-page bg4'>
      <DashboardHeader />
      {/* ---------------------------------------------------------------
          HIDDEN AS REQUESTED: sidebar on the dashboard.

          Every menu item inside DashboardSidebar is already commented out, so
          this rendered a 262px white column with nothing in it - it pushed the
          dashboard content to the right and left a blank gutter.

          Nothing is lost by hiding it: DashboardSidebar is purely presentational
          (useLocation, a localStorage read and <Link>s - no state, no effects,
          no API calls), its logo is already in the header above, and its only
          other content is the empty mobile offcanvas.

          Uncomment to bring the sidebar column back.
      ---------------------------------------------------------------- */}
      {/* <DashboardSidebar /> */}
      {/* 'no-sidebar' cancels the 262px left padding .main-section reserves for
          the fixed .dashboard-sidebar. With the sidebar hidden that padding shows
          up as blank space on the left. The class (defined in main.css) sets
          padding-left: 0 and width: 100%, so the title and cards now span the
          full width. Same treatment ShopPage.js already uses.
          To restore the gutter, change the className back to 'main-section'. */}
      <section className='main-section no-sidebar'>
        <div className='main-inner'>

          <DashboardTitle />

          {/* ---------------------------------------------------------------
              HIDDEN: "After & Before results" section.
              Code kept below for easy restore - uncomment this whole block.
              Note: `.dash-result-block + .dashboard-blocks` in main.css supplies
              the 30px gap above the cards below, so removing this block takes
              that margin with it. The cards sit flush under DashboardTitle
              instead; nothing else moves. Re-commenting/un-commenting needs no
              CSS change either way.
          ---------------------------------------------------------------- */}
          {/*
          <div className='white_box dash-result-block'>
            <div className='box-title'>
              <h4>After & Before results</h4>
            </div>

            <div className='dash-result-list'>
              <Slider {...setting1} className='result-boxes-slider'>
                {sliderimg?.map((item, index) => (
                  <Col key={index} xs={12} md={4} lg={3} className='items'>
                    <div className='card-result-dash'>
                      <div className="imgbox">
                        <img src={item.image_url} alt='' />
                      </div>
                    </div>
                  </Col>
                ))}
              </Slider>
            </div>
          </div>
          */}

          {/* `dash-blocks-gap` (NEW): stands in for the spacing that
              `.dash-result-block + .dashboard-blocks` used to supply above these
              cards. That rule is an adjacent-sibling selector, so with the
              results section commented out it no longer matches anything and the
              cards sat flush under DashboardTitle. This class restores it.

              Deliberately a class rather than an inline style: the original gap
              was 30px on desktop and 20px at <=991px (see the
              `.dash-result-block + .dashboard-blocks` rule in the 991px media
              query), and an inline style cannot be overridden by a media query.
              A class keeps that responsive step intact.

              To revert: delete this className and restore the results section -
              the sibling rule takes over again with no CSS change needed. */}
          <Row className='dashboard-blocks dash-blocks-gap'>
            <Col xs={12} md={8} lg={8} className='left-block'>
              {/* ---------------------------------------------------------------
                  RESTORED: "Order Medicines" card only, from the block below.

                  The original block held all 5 cards (Book an Appointment,
                  Order Medicines, Upload Your Photo, EMI Options, Reserve Your
                  Procedure Slot). Only Order Medicines was asked for, so the
                  other 4 stay inside the comment and can be brought back the
                  same way - move them up into the wrapper below.

                  Every handler is untouched: handleShow() is the original
                  handler from the commented block, and the modal it opens
                  (modalPrescription, further down this file) plus its two
                  buttons' handlers (handleShow2, handleShowWithoutPrescription)
                  were never commented out, so "With Prescription" and
                  "Without Prescription" behave exactly as before.

                  "My Orders" is new. It reuses the same .card-boxes markup and
                  navigates to /myorder, the route the sidebar already links to
                  (see DashboardSidebar.js). If you want it to match the sidebar
                  exactly, give it to='/myorder/' instead - /myorder itself is
                  the plain secondary button colour, so no wrapper class is
                  needed either way.
              ---------------------------------------------------------------- */}
              <div className='dash-boxes-wrapper d-flex stacked'>
                <div className='items'>
                  <div className='card-boxes trans relative'>
                    <Link className='card-link' onClick={handleShow} to=''></Link>
                    <i className='iconbox'>
                      <img src={box_img2} alt='' />
                    </i>
                    <h4>Order Medicines</h4>
                  </div>
                </div>
                <div className='items'>
                  <div className='card-boxes trans relative'>
                    <Link className='card-link' to='/myorder/'></Link>
                    <i className='iconbox'>
                      <img src={box_img5} alt='' />
                    </i>
                    <h4>My Orders</h4>
                  </div>
                </div>
              </div>

              {/* ---------------------------------------------------------------
                  HIDDEN AS REQUESTED: the remaining 4 dashboard action cards
                  (Book an Appointment, Upload Your Photo, EMI Options,
                  Reserve Your Procedure Slot)
                  Code kept below for easy restore - uncomment this whole block.
              ---------------------------------------------------------------- */}
              {/*
              <div className='dash-boxes-wrapper d-flex'>
                <div className='items'>
                  <div className='card-boxes trans relative'>
                    <Link className='card-link' to='/location' onClick={handleAppointmentClick}></Link>
                    <i className='iconbox'>
                      <img src={box_img1} alt='' />
                    </i>
                    <h4>Book an Appointment</h4>
                  </div>
                </div>
                <div className='items'>
                  <div className='card-boxes trans relative'>
                    <Link className='card-link' onClick={handleShow} to=''></Link>
                    <i className='iconbox'>
                      <img src={box_img2} alt='' />
                    </i>
                    <h4>Order Medicines</h4>
                  </div>
                </div>
                <div className='items'>
                  <div className='card-boxes trans relative'>
                    <Link className='card-link' to='/myphotos'></Link>
                    <i className='iconbox'>
                      <img src={box_img3} alt='' />
                    </i>
                    <h4>Upload Your Photo</h4>
                  </div>
                </div>
                <div className='items'>
                  <div className='card-boxes trans relative'>
                    <Link className='card-link'  to={user?.user?.emi_option_status === 1 ? "/emioptions" : "/apply-emi"}Z></Link>
                    <i className='iconbox'>
                      <img src={box_img4} alt='' />
                    </i>
                    <h4>EMI Options</h4>
                  </div>
                </div>
                <div className='items'>
                  <div className='card-boxes trans relative'>
                    <Link className='card-link' to='/location' onClick={handleClick}></Link>
                    <i className='iconbox'>
                      <img src={surgery_icon} alt='' width='40' />
                    </i>
                    <h4>Reserve Your Procedure Slot </h4>
                  </div>
                </div>
              </div>
              */}
            </Col>

            <Col xs={12} md={4} lg={4} className='right-block'>
              <div className='white_box testimonial-wrapper'>
                <div className='box-title'>
                  <h4>Recent Reviews</h4>
                </div>

                <div src={"https://cdn.trustindex.io/loader.js?906599d1520f8065485696d3394"}></div>

              </div>
            </Col>
          </Row>
          {/* backdrop='static' + keyboard={false} (NEW): this popup now stays on
              the page. React-bootstrap's Modal closes on a backdrop click and on
              Escape by default, and both routes call onHide -> handleClose, which
              is why clicking anywhere on the page made it disappear.

              With these two props the ONLY ways out are the two buttons in this
              modal's body ("With Prescription" / "Without Prescription"), so those
              still work exactly as before. There is no X button to remove - this
              Modal renders only a Modal.Body, and react-bootstrap adds a close
              button only when a Modal.Header is present.

              Side effect worth knowing: because handleClose() (which clears
              localStorage 'show_medicine_popup') no longer runs on stray clicks,
              the popup keeps auto-opening on every visit to the dashboard until
              one of the two options is actually chosen. That is the point of
              "always on the dashboard", but if you only wanted it to stop closing
              on background clicks while still clearing after login, move the
              localStorage.removeItem back into the auto-open useEffect instead.

              PREVIOUS (kept for restore):
              <Modal id="modalPrescription" show={show} onHide={handleClose} size="md" aria-labelledby="contained-modal-title-vcenter" centered>
          */}
          <Modal id="modalPrescription" show={show} onHide={handleClose} backdrop='static' keyboard={false} size="md" aria-labelledby="contained-modal-title-vcenter" centered>
            {/* Close (X). NEW - restores the escape route that backdrop='static'
                + keyboard={false} above took away: without it the ONLY ways out
                were the two choice buttons, so the popup could not be dismissed
                to look at the dashboard behind it.

                It calls handleClose and nothing else - the same handler the
                "With Prescription" button already calls, which sets show=false
                and clears the 'show_medicine_popup' flag. No new state, no new
                handler, and the buttons below are untouched - so the modal still
                reopens normally from the "Order Medicines" card (handleShow).

                Rendered as a real <button> with an aria-label rather than a
                Link: it is an action, not navigation, and this way it is
                keyboard-focusable and announced by screen readers. */}
            <button
              type='button'
              className='modal-close-x'
              onClick={handleClose}
              aria-label='Close'
            >
              <i className='las la-times'></i>
            </button>
            <Modal.Body>
              <div className='appoint-booking-body ptb-20 pb-0 text-center'>
                <p className='text-20'>Do you want to buy medicine with prescription or without prescription?</p>
                <div className='btnbox ptb-20 pb-0 d-flex'>
                  <div className='btn-items' onClick={handleClose}>
                    <Link className='btn primary small' onClick={handleShow2} to=''>With Prescription</Link>
                  </div>
                  <div className='btn-items'>
                    <Link className='btn secondary small' onClick={handleShowWithoutPrescription} to='' >Without Prescription</Link>
                  </div>
                </div>
              </div>
            </Modal.Body>
          </Modal>
          <Modal id="modalPreDoc" show={show2} onHide={handleClose2} size="md" aria-labelledby="contained-modal-title-vcenter" centered>
            <Modal.Body>
              <div className='appoint-booking-body'>
                <h2>Prescription Documents</h2>
                <Form className='form-inner emi-form-main' onSubmit={handleSubmit} ref={form}>
                  <div className='input-field full-width'>
                    <label className='label'>Upload Prescription</label>
                    <div className={`file-upload-box ${myclass1}`}>
                      <label className='upload-img1 w-100'>
                        <Input className='upload-pre' type="file"onChange={handleChange1} />
                        <div className='drag-drop-box d-flex'>
                          <i className="las la-file-pdf"></i><span>Drag & Drop or Choose file to upload</span>
                        </div>
                        <div className='uploaded-files'>
                          <i className="las la-file"></i>{file1}
                        </div>
                      </label>
                    </div>
                    {/*<small className='allow-file-label label mb-0 pt-2'>Only ( .pdf, .doc, .docx ) are allowed</small>*/}
                    {fileError && <div className="alert alert-danger mt-3" role="alert">{fileError}</div>}
                  </div>

                  <div className='input-field full-width mb-0 d-flex'>
                    <div className='btnbox pt-0 d-flex v-center'>
                      <button type='submit' className='btn secondary'>Submit</button>
                      <Link onClick={handleClose2} className='btn primary ml-2'>Cancel</Link>
                    </div>
                  </div>
                </Form>
              </div>
            </Modal.Body>
          </Modal>
          <Modal id="modalWithoutPreDoc" show={ShowWithoutPrescription} onHide={() => { handleCloseWithoutPrescription(); }} size="md" aria-labelledby="contained-modal-title-vcenter" centered>
            <Modal.Body>
              <div className='appoint-booking-body'>
                <h2>Request a Prescription</h2>
                <PrescriptionModal />
              </div>
            </Modal.Body>
          </Modal>
          <Modal id="modalThankyou" show={show3} onHide={handleClose3} size="md" aria-labelledby="contained-modal-title-vcenter" centered>
            <Modal.Body>
              <div className='appoint-booking-body text-center thankyou-inn'>
                <div className='thankyou-innbox'>
                  <i className='thankyou-iconbox d-flex'><img src={thankyou_icon} alt='' /></i>
                  <h3><strong>Thank you for the prescription.</strong></h3>
                  <p>You can buy De</p>
                </div>
              </div>
            </Modal.Body>
          </Modal>
        </div>
      </section>
    </div>
  )
}
export default Dashboard